import { memo } from 'react';
import { cn } from '@/shared/utils/cn';
import { LabelProgressProps } from '@/shared/types/progressbar';

/**
 * Componente de Label para el ProgressBar
 * Sigue las especificaciones de Figma: type/body/xs/medium
 *
 * @example
 * // Solo texto
 * <LabelProgress label="Descargando archivo..." />
 *
 * // Con valor numérico
 * <LabelProgress value={75} suffix="%" />
 *
 * // Combinado
 * <LabelProgress label="200MB de 512MB" />
 */
export const LabelProgress = memo(
  ({ label, value, suffix = '', className }: LabelProgressProps) => {
    // Si tiene valor, mostrar valor + sufijo
    if (typeof value === 'number') {
      return (
        <span
          className={cn(
            'ui-text-body-xs-regular ui-font-body-xs-medium',
            'ui-whitespace-nowrap ui-text-secondary',
            className
          )}
        >
          <span className="ui-text-right">{value}</span>
          {suffix && <span>{suffix}</span>}
        </span>
      );
    }

    // Si solo tiene label, mostrar label
    if (label) {
      return (
        <span
          className={cn(
            'ui-text-body-xs-regular ui-font-body-xs-medium',
            'ui-whitespace-nowrap ui-text-primary',
            className
          )}
        >
          {label}
        </span>
      );
    }

    return null;
  }
);

LabelProgress.displayName = 'LabelProgress';
